import { NodeSummary } from "../utils/query";
import { UserRound, Users, Building, Rotate3D } from "lucide-react";
import { Link } from "react-router";

type ListNodeViewProps = {
    person: NodeSummary;
    isSelected: boolean;
    onSelect: (id: string, isSelected: boolean) => void;
}

const typeIconMap = {
    person: <UserRound className="w-4 h-4 text-gray-500" />,
    group: <Users className="w-4 h-4 text-gray-500" />,
    entity: <Building className="w-4 h-4 text-gray-500" />,
    effort: <Rotate3D className="w-4 h-4 text-gray-500" />,
}

export const ListNodeView = (props: ListNodeViewProps) => {
    const { person, isSelected, onSelect } = props;
    return (
        <div key={person.id} className="bg-base-100 border p-1 rounded-sm flex items-center justify-between">

            <div className="flex items-center">
                <input
                    type="checkbox"
                    checked={isSelected}
                    onChange={(e) => onSelect(person.id, e.target.checked)}
                    className="checkbox checkbox-sm mr-2 ml-2"
                    aria-label={`Select ${person.id}`} />

                <div className="flex items-center gap-2">
                    {/* Avatars (single or multiple) */}
                    <div className="avatar-group -space-x-6">
                        {person.avatars.length === 0 && (
                            <div className="avatar placeholder">
                                <div className="bg-neutral text-neutral-content w-8 rounded-full ring ring-primary ring-offset-base-100 ring-offset-1">
                                    <span><Link to={`nodes/${person.id}`}> {person.name[0].toUpperCase()}</Link></span>
                                </div>
                            </div>
                        )}
                        {person.avatars.map((avatarUrl, i) => (
                            <div key={i} className="avatar" style={{ zIndex: person.avatars.length - i }}>
                                <div className="w-8 rounded-full ring ring-primary ring-offset-base-100 ring-offset-1">
                                    <img src={avatarUrl} alt={`${person.name}'s avatar`} />
                                </div>
                            </div>
                        ))}
                    </div>

                    <div>
                        <h2 className="text-lg font-semibold">
                            <Link to={`nodes/${person.id}`}> {person.name}</Link>
                        </h2>
                        <p className="text-sm">{person.subtitle}</p>
                    </div>
                </div>
            </div>

            {typeIconMap[person.type]}
        </div>
    )
}